export default __webpack_public_path__ + "static/media/pizzaLeft.24b07891.jpg";